import { render, staticRenderFns } from "./RoomCorridorEntrance.vue?vue&type=template&id=63fc3d0c&scoped=true"
import script from "./RoomCorridorEntrance.vue?vue&type=script&lang=ts"
export * from "./RoomCorridorEntrance.vue?vue&type=script&lang=ts"
import style0 from "./RoomCorridorEntrance.vue?vue&type=style&index=0&id=63fc3d0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc3d0c",
  null
  
)

export default component.exports